<template>
    <!-- Generato da claude — Dashboard Deskalo redesign Proposta A -->
    <div>
        <!-- Welcome banner -->
        <div class="dk-welcome">
            <div class="dk-welcome-left">
                <div class="dk-welcome-text">
                    <small>{{benvenuto}} 👋</small>
                    <strong>{{utente.NOME}} {{utente.COGNOME}}</strong>
                </div>
            </div>
            <div class="dk-welcome-badge" v-if="societaNome">
                {{societaNome}}
            </div>
        </div>

        <!-- Tile grid -->
        <div class="dk-tile-grid">

            <!-- Shop / Pagamento -->
            <div v-if="PAGAMENTI_ONLINE_ABILITATI == 1" class="dk-tile" @click="shop()">
                <span class="dk-tile-badge" v-if="home.CARRELLO && home.CARRELLO.ITEMS && home.CARRELLO.ITEMS.length > 0">
                    {{home.CARRELLO.ITEMS.length}}
                </span>
                <div class="dk-tile-icon">🛒</div>
                <div class="dk-tile-title">Pagamento</div>
                <div class="dk-tile-sub" v-if="home.CARRELLO && home.CARRELLO.ITEMS && home.CARRELLO.ITEMS.length > 0">
                    {{home.CARRELLO.ITEMS.length}} nel carrello
                </div>
                <div class="dk-tile-sub" v-else>Effettua un pagamento</div>
            </div>
            <div v-else class="dk-tile" style="opacity:.5;cursor:default">
                <div class="dk-tile-icon" style="background:#eee">🛒</div>
                <div class="dk-tile-title">Pagamento</div>
                <div class="dk-tile-sub">Non disponibile</div>
            </div>

            <!-- Prenotazioni -->
            <div class="dk-tile" @click="prenotazioni()">
                <span class="dk-tile-badge" v-if="home.PRENOTAZIONI && home.PRENOTAZIONI.length > 0">
                    {{home.PRENOTAZIONI.length}}
                </span>
                <div class="dk-tile-icon">📅</div>
                <div class="dk-tile-title">Prenotazioni</div>
                <div class="dk-tile-sub" v-if="home.PRENOTAZIONI && home.PRENOTAZIONI.length > 0">
                    {{home.PRENOTAZIONI.length}} corsi attivi
                </div>
                <div class="dk-tile-sub" v-else>Nessuna prenotazione</div>
            </div>

            <!-- Abbonamenti -->
            <div class="dk-tile" @click="abbonamenti()">
                <div class="dk-tile-icon">🎟️</div>
                <div class="dk-tile-title">Abbonamenti</div>
                <div class="dk-tile-sub" v-if="nAbbonamentiValidi > 0">
                    {{nAbbonamentiValidi}} valido/i
                </div>
                <div class="dk-tile-sub" v-else>Nessun abbonamento</div>
            </div>

            <!-- Messaggi dalla segreteria -->
            <div class="dk-tile" @click="richieste()">
                <span class="dk-tile-badge" v-if="home.NOTIFICHE > 0">{{home.NOTIFICHE}}</span>
                <div class="dk-tile-icon">💬</div>
                <div class="dk-tile-title">Messaggi</div>
                <div class="dk-tile-sub" v-if="home.NOTIFICHE > 0">
                    {{home.NOTIFICHE}} dalla segreteria
                </div>
                <div class="dk-tile-sub" v-else>Nessun messaggio</div>
            </div>

            <!-- Nuova anagrafica — nascosto temporaneamente -->
            <div v-if="false" class="dk-tile" @click="anagrafica()">
                <div class="dk-tile-icon">👤</div>
                <div class="dk-tile-title">Anagrafica</div>
                <div class="dk-tile-sub">Nuova richiesta</div>
            </div>

            <!-- Ricevute -->
            <div class="dk-tile" @click="ricevute()">
                <div class="dk-tile-icon">🧾</div>
                <div class="dk-tile-title">Ricevute</div>
                <div class="dk-tile-sub">Storico pagamenti</div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'Dashboard',
    data: function() {
        return {
            utente: {},
            home: {
                CARRELLO: { ITEMS: [] },
                PRENOTAZIONI: [],
                NOTIFICHE: 0,
                ABBONAMENTI: [],
                PAGAMENTI_ONLINE_ABILITATI: 0,
            },
            PAGAMENTI_ONLINE_ABILITATI: 0,
        }
    },
    computed: {
        benvenuto() {
            return this.utente.SESSO == 2 ? 'Benvenuta' : 'Benvenuto';
        },
        societaNome() {
            if (this.home.SOCIETA && this.home.SOCIETA.DENOMINAZIONE) return this.home.SOCIETA.DENOMINAZIONE;
            const s = this.$root.SOCIETA_SPECIFICA;
            return s && s.DENOMINAZIONE ? s.DENOMINAZIONE : '';
        },
        nAbbonamentiValidi() {
            if (!this.home.ABBONAMENTI) return 0;
            return this.home.ABBONAMENTI.filter(a => a.VALIDITA_DURATA == 1 && a.VALIDITA_INGRESSI == 1).length;
        },
    },
    methods: {
        prenotazioni() { global.router.push('Prenotazioni'); },
        shop()         { global.router.push('Shop'); },
        ricevute()     { global.router.push('ricevute'); },
        abbonamenti()  { global.router.push('abbonamenti'); },
        anagrafica()   { global.router.push('Anagrafica'); },
        richieste()    { global.router.push('Richieste'); },
        continuaShopping() {
            if (this.home.CARRELLO && this.home.CARRELLO.ID_NEGOZIO) {
                global.router.push('Shop');
            }
        },
    },
    // Generato da claude — Deskalo 2: home dati dal socio loggato via PIN
    created: function() {
        this.utente = this.$root.utente;
        if (!global.utils.SESSION_TOKEN) return;
        global.utils.ajax('deskalo/home', {}, (response) => {
            if (response.esito == 0) {
                this.home = response.data;
                this.PAGAMENTI_ONLINE_ABILITATI = response.data.PAGAMENTI_ONLINE_ABILITATI;
                // Espone le stats al BottomNav tramite $root
                this.$root.homeStats = response.data;
            }
        });
    },
}
</script>
